// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27F4W","badges":"styles_badges__3PtEg"};